// extracted by mini-css-extract-plugin
export default {"container":"RelatedConceptItem__container___GKtML"};